import { Link, useParams, useSearchParams } from 'react-router-dom';
import { CheckIcon, JobPage, Spinner, useOutbox } from '../components.jsx';

const DONE_TEXT = {
  note: 'Note saved',
  files: 'Files uploaded',
  contact: 'Contact added',
  goods: 'Goods recorded',
};

function Body({ job }) {
  const [sp] = useSearchParams();
  const what = sp.get('what') || 'note';
  const sid = sp.get('sid');
  const total = Number(sp.get('n')) || 0;
  const { items, authRequired } = useOutbox();

  const mine = sid ? items.filter((i) => i.sid === sid) : [];
  const failed = mine.filter((i) => i.state === 'failed');
  const pending = mine.length > 0;
  const filesLeft = mine.filter((i) => i.kind === 'file').length;

  return (
    <div className="space-y-6 py-6 text-center">
      <div
        className={`mx-auto flex h-24 w-24 items-center justify-center rounded-full ${
          failed.length ? 'bg-ascred' : pending ? 'bg-amber' : 'bg-green-600'
        } text-white`}
      >
        {pending && !failed.length ? <Spinner className="h-10 w-10 !border-charcoal !border-t-transparent" /> : <CheckIcon className="h-14 w-14" />}
      </div>

      {failed.length ? (
        <div>
          <h2 className="text-2xl font-bold">Some items didn't send</h2>
          <p className="mt-1 text-steel">Tap "Details" in the yellow bar at the top to retry.</p>
        </div>
      ) : pending ? (
        <div>
          <h2 className="text-2xl font-bold">{authRequired ? 'Sign in to finish' : 'Sending…'}</h2>
          <p className="mt-1 text-steel">
            {what === 'files' && total > 0 ? `${Math.max(0, total - filesLeft)} of ${total} uploaded. ` : ''}
            Keep this screen open until it finishes.
          </p>
        </div>
      ) : (
        <div>
          <h2 className="text-2xl font-bold">{DONE_TEXT[what] || 'Saved'}</h2>
          <p className="mt-1 text-steel">{job.name}</p>
        </div>
      )}

      <div className="space-y-3">
        <Link to={`/job/${job.id}`} className="btn-primary w-full">Add something else to this job</Link>
        <Link to="/" className="btn-ghost w-full">Choose a different job</Link>
      </div>
    </div>
  );
}

export default function Done() {
  useParams();
  return <JobPage>{(job) => <Body job={job} />}</JobPage>;
}
